var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpFormGroup",
        { attrs: { labelColsMd: "3", contentColsMd: "9" } },
        [
          _c("ItpButton", {
            attrs: {
              text: _vm._f("pgettext")("Get printer attributes...", "Button"),
              spinning:
                _vm.actions.getAttributes && _vm.actions.getAttributes.isRunning
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.evh_8564662037462133_clickPrevent($event, {})
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            labelColsMd: "3",
            contentColsMd: "9",
            label: _vm._f("pgettext")("Print file", "PrinterConfig"),
            helpTooltip: _vm._f("pgettext")(
              "Select a file to send to the network printer for testing purposes.",
              "PrinterConfig"
            )
          }
        },
        [
          _c("b-form-file", {
            staticClass: "col mb-3",
            attrs: {
              placeholder: _vm._f("pgettext")(
                "Choose a file or drop it here",
                "PrinterConfig"
              ),
              "drop-placeholder": _vm._f("pgettext")(
                "Drop file here",
                "PrinterConfig"
              ),
              lang: "hu",
              accept: "pdf"
            },
            model: {
              value: _vm.selectedFile,
              callback: function($$v) {
                _vm.selectedFile = $$v
              },
              expression: "selectedFile"
            }
          }),
          _vm._v(" "),
          _c("ItpButton", {
            staticClass: "col-auto",
            attrs: {
              disabled: !_vm.selectedFile,
              text: _vm._f("gettext")("Print"),
              icon: "fa-printer",
              spinning:
                _vm.actions.printFileAction &&
                _vm.actions.printFileAction.isRunning
            },
            on: {
              click: function($event) {
                return _vm.evh_4186377094414664_click($event, {})
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.jobs && _vm.jobs.length
        ? _c("table", { staticClass: "table table-condensed table-sm" }, [
            _c("thead", [
              _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("pgettext")("ID", "PrinterTester|ColHead")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("pgettext")("State", "PrinterTester|ColHead")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("pgettext")(
                          "State reasons",
                          "PrinterTester|ColHead"
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.jobs, function(item) {
                return _c("tr", { key: item.id }, [
                  _c(
                    "td",
                    [
                      _c("ItpButton", {
                        attrs: {
                          text: _vm._f("gettext")("Reload"),
                          icon: "fa-refresh",
                          spinning: item.busy
                        },
                        on: {
                          click: function($event) {
                            return _vm.evh_4747808328624104_click($event, {
                              item: item
                            })
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [_c("strong", [_vm._v(_vm._s(item.id))])]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n          " + _vm._s(item.state) + "\n        ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n          " + _vm._s(item.state_reasons) + "\n        "
                    )
                  ])
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }